// extracted by mini-css-extract-plugin
export default {"RegisterView":"RegisterView_RegisterView__Sz-uz"};